export function caminhoParaPermissao(path: string) {
  return path.replace("/gestor/", "acesso/").replace(/-/g, "").replace(/\//g, "-");
}
